export default "assets/criticalog-logo.png"